// Hover tooltips with keyword colours. Anything hoverable calls tip(...) handlers.
import { useEffect, useState, type ReactNode } from 'react';
import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';

interface TipState {
  content: ReactNode | null;
  x: number;
  y: number;
}
const tipStore = createStore<TipState>(() => ({ content: null, x: 0, y: 0 }));

function toLogical(e: { clientX: number; clientY: number }): { x: number; y: number } {
  const ui = document.getElementById('ui');
  const r = ui?.getBoundingClientRect();
  if (!r) return { x: 0, y: 0 };
  return { x: ((e.clientX - r.left) / r.width) * 640, y: ((e.clientY - r.top) / r.height) * 360 };
}

/** Spread onto any element: {...tip(<content/>)} */
export function tip(content: ReactNode) {
  return {
    onMouseEnter: (e: React.MouseEvent) => tipStore.setState({ content, ...toLogical(e) }),
    onMouseMove: (e: React.MouseEvent) => tipStore.setState(toLogical(e)),
    onMouseLeave: () => tipStore.setState({ content: null }),
  };
}

export function hideTip(): void {
  tipStore.setState({ content: null });
}

export function TooltipLayer() {
  const { content, x, y } = useStore(tipStore);
  const [size, setSize] = useState({ w: 150, h: 40 });
  const [el, setEl] = useState<HTMLDivElement | null>(null);
  useEffect(() => {
    if (el) setSize({ w: el.offsetWidth, h: el.offsetHeight });
  }, [el, content]);
  if (!content) return null;
  const left = Math.round(Math.min(640 - size.w - 4, x + 10));
  const top = Math.round(y + 14 + size.h > 356 ? y - size.h - 6 : y + 14);
  return (
    <div className="tooltip" ref={setEl} style={{ left, top }}>
      {content}
    </div>
  );
}
